import React, { useCallback, useMemo } from "react";
import { prepareTableSourceDataForSelect, } from "../../../ResultElementBaseSourceSelect/utils";
import ResultElementBaseSourceSelect from "../../../ResultElementBaseSourceSelect";
import { ResultElementSourceType, TableElementSourceType, } from "store/rs-workspace/rs-workspace.types";
import { getSourcesForFilter } from "../../utils";
import { isNotEmpty } from "utils/validate";
import { OptimizationLabels } from "shared/labels";
const RowDialog = ({ row, rows, onClose, onSubmit, classes }) => {
    const sourcesForFilter = useMemo(() => ({
        simulations: getSourcesForFilter(ResultElementSourceType.Simulation, rows, row?.id),
        processData: getSourcesForFilter(ResultElementSourceType.ProcessData, rows, row?.id),
    }), [row?.id, rows]);
    const getSubmitDisabledData = useCallback((values) => {
        let currentSourceId;
        switch (values.type) {
            case ResultElementSourceType.Simulation:
                currentSourceId = values.simulationId ?? null;
                break;
            case ResultElementSourceType.ProcessData:
                currentSourceId = values.processDataId ?? null;
                break;
            case ResultElementSourceType.Insight:
                currentSourceId = values.insightId ?? null;
                break;
        }
        const conditions = [!isNotEmpty(currentSourceId)];
        if (values.type === ResultElementSourceType.Simulation) {
            const currentOptimizationId = values.optimizationId ?? null;
            const currentVariantId = values.adjustmentId;
            const simulationsMap = rows
                .filter(({ sourceType }) => sourceType === TableElementSourceType.SIMULATION)
                .map(({ sourceId, adjustmentId, optimizationId }) => `${sourceId}-${adjustmentId}-${optimizationId ?? null}`);
            conditions.push(!isNotEmpty(currentVariantId));
            conditions.push(simulationsMap.includes(`${currentSourceId}-${currentVariantId}-${currentOptimizationId}`));
        }
        const disabled = conditions.some(Boolean);
        return {
            disabled,
            message: isNotEmpty(currentSourceId) && disabled ? OptimizationLabels.INCORRECT_SOURCE : "",
        };
    }, [rows]);
    const internalSubmit = useCallback((values) => {
        let template = row ? { ...row } : {};
        switch (values.type) {
            case ResultElementSourceType.ProcessData:
                template = {
                    ...template,
                    ...values,
                    sourceType: TableElementSourceType.PROCESS_DATA,
                    sourceId: values.processDataId,
                };
                break;
            case ResultElementSourceType.Simulation:
                template = {
                    ...template,
                    ...values,
                    sourceType: TableElementSourceType.SIMULATION,
                    sourceId: values.simulationId,
                    optimization: values.optimizationId,
                };
                break;
        }
        onSubmit(template);
        onClose();
    }, [onClose, onSubmit, row]);
    return (React.createElement(ResultElementBaseSourceSelect, { title: "Data source", allowedTypes: [ResultElementSourceType.ProcessData, ResultElementSourceType.Simulation], initialValues: prepareTableSourceDataForSelect(row), onSubmit: internalSubmit, onClose: onClose, withSimulationOptimization: true, sourcesForFilter: sourcesForFilter, classes: classes, getSubmitDisabledData: getSubmitDisabledData }));
};
export default RowDialog;
